import React, { Component } from "react";
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";

import PostDetail from "./PostDetail";

library.add(faPlusCircle);

class PostList extends Component {
  constructor(props) {
    super(props);
    this.state = {
       ...props
    }
  }
  
  render(){
    const { boothId, postList } = this.state;
    const postDetails = postList.map((post, index)=>{
      const { postId } = post;
      return <PostDetail key={postId} info={post} />;
    })
    return(
      <div className="post-list">
        <Container>
          <Row>
            <Col xs="4" className="post-upload">
              <Link to = {{
                pathname: `/booth/${boothId}/upload`,
                state: { boothId: boothId, from: 'Posts' },
              }}>
                <FontAwesomeIcon icon="plus-circle" /> 참여하기
              </Link>
            </Col>

            {postDetails}
          </Row>
        </Container>
        
      </div>
    );
  }
}
export default PostList;